import { PostHogConfig } from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

const postHogOptions: Partial<PostHogConfig> = {
  api_host: 'https://us.i.posthog.com',
  defaults: '2026-01-30',
  persistence: 'localStorage+cookie',
  cross_subdomain_cookie: true,
  capture_exceptions: true,
  capture_heatmaps: true,
  capture_performance: true,
  ip: true,
  name: 'enrich app',
};

const isLocalhost =
  window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

export function EnrichPostHogProvider({ children }: { children: React.ReactNode }) {
  if (isLocalhost) {
    return <>{children}</>;
  }

  return (
    <PostHogProvider apiKey={import.meta.env.VITE_POSTHOG_KEY} options={postHogOptions}>
      {children}
    </PostHogProvider>
  );
}
